/* eslint-disable max-len */
var ICON_UI_CHEVRON_LEFT = {
  v2: true,
  "default": 'M16.25 23.25L5.53 12.53C5.46033 12.4604 5.40507 12.3778 5.36736 12.2869C5.32965 12.1959 5.31024 12.0984 5.31024 12C5.31024 11.9016 5.32965 11.8041 5.36736 11.7131C5.40507 11.6222 5.46033 11.5396 5.53 11.47L16.25 0.75',
  globetrotter: 'M17.0625 22.125L6.9375 12L17.0625 1.875'
};

export { ICON_UI_CHEVRON_LEFT };
//# sourceMappingURL=ICON_UI_CHEVRON_LEFT.js.map
